module.exports = __webpack_public_path__ + "static/media/997230.b86abae3.png";